import { IcInfo16 } from '@assets/icons/16x16';
import { Box, Button, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import ErrorsContainer from '@components/common/form/ErrorsContainer';
import { DraggablePanel } from '@components/ui/draggable';
import { createToast, ToastStatusEnum } from '@components/ui/toaster';
import { useAddMarksMutation } from '@services/c2/track.api';
import { createErrorMessage } from '@utils/common.utils';
import { FormattedMessage, useIntl } from 'react-intl';

import { MarkEnum } from '@/types/commons/commons.types';
import { PopupComponentProps, PopupTypeEnum } from '@/types/popup.types';

export default function ShareTargetOnHoloviewPopup({
  mapConstraintsRef,
  top,
  left,
  data,
  onClose,
}: Readonly<PopupComponentProps<PopupTypeEnum.SHARE_HOLOVIEW>>) {
  const { site, trackIds } = data;
  const { formatMessage } = useIntl();
  const [addMarks, { isLoading, isError, error }] = useAddMarksMutation();

  return (
    <DraggablePanel.Root constraintsRef={mapConstraintsRef} top={top} left={left}>
      <DraggablePanel.Header onClose={onClose}>
        <FormattedMessage id="shareOnHoloview.title" />
      </DraggablePanel.Header>
      <DraggablePanel.Body width={483}>
        <VStack backgroundColor="neutral.700" width="100%" flex={1} padding={4} gap={4} alignItems="start">
          <Text width="100%" textStyle="screenStd" whiteSpace="pre-line">
            <FormattedMessage id="shareOnHoloview.description" />
          </Text>
          <HStack gap={2}>
            <Icon as={IcInfo16} color="neutral.white" boxSize={{ base: '24px', '4k': '32px' }} />
            <Text textStyle="screenStd">
              <FormattedMessage id="global.unrecoverableAction" />
            </Text>
          </HStack>
          {error && (
            <Box height="40px">
              <ErrorsContainer errors={{}} touched={{}} apiError={isError ? createErrorMessage(error) : undefined} />
            </Box>
          )}
          <HStack width="100%" gap={2} justifyContent="center">
            <Box borderWidth="2px" borderColor="blue.700">
              <Button variant="secondary" onClick={onClose}>
                <FormattedMessage id="global.cancel" />
              </Button>
            </Box>
            <Box borderWidth="2px" borderColor="blue.700">
              <Button
                disabled={isLoading || isError}
                loading={isLoading}
                onClick={() =>
                  addMarks({
                    site: site,
                    trackIds: trackIds,
                    marks: [MarkEnum.CRISIS],
                  })
                    .unwrap()
                    .then(() => {
                      createToast(formatMessage({ id: 'shareOnHoloview.successToast' }), ToastStatusEnum.SUCCESS);
                      onClose();
                    })
                }
              >
                <FormattedMessage id="shareOnHoloview.confirm" />
              </Button>
            </Box>
          </HStack>
        </VStack>
      </DraggablePanel.Body>
    </DraggablePanel.Root>
  );
}
